/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_violin_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two bulges in one violin reveal a bimodal distribution a box plot would hide.`)
};

const es_violin_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos abultamientos en un violín revelan una distribución bimodal que un diagrama de caja ocultaría.`)
};

const de_violin_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwei Wölbungen in einer Violine zeigen eine bimodale Verteilung, die ein Boxplot verbergen würde.`)
};

const nl_violin_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twee uitstulpingen in één viool onthullen een bimodale verdeling die een boxplot zou verbergen.`)
};

const fr_violin_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deux renflements dans un violon révèlent une distribution bimodale qu'un box plot masquerait.`)
};

const it_violin_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due rigonfiamenti in un violino rivelano una distribuzione bimodale che un box plot nasconderebbe.`)
};

const pt_br2_violin_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dois alargamentos em um violino revelam uma distribuição bimodal que um box plot esconderia.`)
};

const pt_violin_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas protuberâncias num só violino revelam uma distribuição bimodal que um box plot ocultaria.`)
};

const ja_violin_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1つのバイオリンに2つの膨らみがある場合、箱ひげ図では見えない二峰性の分布を示しています。`)
};

const zh_violin_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一个小提琴中出现两个鼓起说明存在双峰分布，这是箱形图无法揭示的。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const violin_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.violin_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("violin_ex3", locale)
	if (locale === "en") return en_violin_ex3(inputs)
	if (locale === "es") return es_violin_ex3(inputs)
	if (locale === "de") return de_violin_ex3(inputs)
	if (locale === "nl") return nl_violin_ex3(inputs)
	if (locale === "fr") return fr_violin_ex3(inputs)
	if (locale === "it") return it_violin_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_violin_ex3(inputs)
	if (locale === "pt") return pt_violin_ex3(inputs)
	if (locale === "ja") return ja_violin_ex3(inputs)
	return zh_violin_ex3(inputs)
};